var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageHeroPressGoogleNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 38,
    viewBox: "0 0 106 38",
    width: 106,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.352051 0h104.808v38h-104.808z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.2879 25.7716c0 .6481-.5326 1.177-1.1845 1.177h-25.0676c-.6518 0-1.18448-.5289-1.18448-1.177v-24.59458c0-.648105.53268-1.17702 1.18448-1.17702h25.0676c.6519 0 1.1845.528915 1.1845 1.17702z",
    fill: "#000",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.9338 25.0154c-.1676.6332.1676 1.2776.7524 1.4303l23.2164 6.2427c.5811.1564 1.1994-.2347 1.367-.8642l5.4679-20.4116c.1677-.6332-.1676-1.2776-.7524-1.43034l-23.2164-6.2427c-.581-.15644-1.1994.23466-1.367.86414z",
    fill: "#000",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.0019 5.41974 1.0951.29426.6779 4.5777z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.2185 22.5011c.2235.6146-.0558 1.285-.622 1.4936l-24.50147 8.9171c-.56616.2049-1.21427-.1266-1.43775-.7412l-7.226039-19.8605c-.223486-.6145.055872-1.285.622039-1.4936l24.50142-8.91705c.5662-.20486 1.2143.12664 1.4378.74122z",
    fill: "#000",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.5079 36.8042c0 .6518-.5326 1.1882-1.1882 1.1882h-33.50046c-.65183 0-1.1882-.5327-1.1882-1.1882v-25.3247c0-.6518.53264-1.1882 1.1882-1.1882h33.50426c.6518 0 1.1882.5327 1.1882 1.1882v25.3247z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.1124 20.3152h-10.027v-2.6372h10.0233c.2905 0 .5289.2347.5289.529v1.583c0 .2905-.2346.5252-.5252.5252z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.1124 30.3421h-10.027v-2.6371h10.0233c.2905 0 .5289.2346.5289.5289v1.583c0 .2868-.2346.5252-.5252.5252z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.6955 25.3285h-11.6101v-2.6372h11.6063c.2906 0 .529.2347.529.529v1.583c0 .2905-.2347.5252-.5252.5252z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.3197 37.728h-33.50046c-.65183 0-1.1882-.5326-1.1882-1.1882v.2645c0 .6518.53264 1.1882 1.1882 1.1882h33.50426c.6518 0 1.1882-.5327 1.1882-1.1882v-.2645c-.0038.6518-.5364 1.1882-1.192 1.1882z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.1158 22.956v2.3801h3.4156c-.283 1.449-1.5569 2.4994-3.4156 2.4994-2.0709 0-3.7545-1.7544-3.7545-3.8254 0-2.0709 1.6799-3.8253 3.7545-3.8253.935 0 1.7693.3203 2.4286.9498l1.8065-1.8065c-1.0988-1.0243-2.5291-1.6501-4.2351-1.6501-3.4975 0-6.33205 2.8346-6.33205 6.3321 0 3.4976 2.83455 6.3321 6.33205 6.3321 3.6578 0 6.064-2.5701 6.064-6.1868 0-.4135-.0373-.8157-.1006-1.1994z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.183 25.3322v.2644h3.3486c.0261-.0857.0447-.1751.0633-.2644z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.1835 30.3422c-3.4529 0-6.25763-2.7637-6.3284-6.198 0 .0447-.00372.0894-.00372.1304 0 3.4975 2.83452 6.3321 6.33212 6.3321 3.6577 0 6.0639-2.5701 6.0639-6.1868 0-.0298-.0037-.0559-.0037-.0857-.082 3.5199-2.4658 6.008-6.0602 6.008z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.6119 21.1343c-.6593-.6295-1.4974-.9498-2.4286-.9498-2.0709 0-3.7545 1.7543-3.7545 3.8253 0 .0447.0037.0894.0074.1303.0708-2.015 1.7171-3.6949 3.7471-3.6949.9349 0 1.7693.3203 2.4286.9498l1.9368-1.9369c-.0446-.0409-.0968-.0819-.1415-.1229z",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "m35.6376 20.0503v-.2645c0 .2906-.2346.5289-.5289.5289h-10.0233v.2645h10.0233c.2943 0 .5289-.2347.5289-.5289z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.1124 30.3419h-10.027v.2645h10.0233c.2905 0 .5289-.2347.5289-.529v-.2644c0 .2905-.2346.5289-.5252.5289z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.6955 25.3286h-11.6101v.2645h11.6063c.2906 0 .529-.2347.529-.529v-.2644c0 .2942-.2347.5289-.5252.5289z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.8264 16.9438c-3.4715 0-6.3321-2.7936-6.3321-6.3321 0-3.54225 2.8606-6.3321 6.3321-6.3321 1.6351 0 3.1995.61459 4.3579 1.76926l-1.2254 1.22545c-.8157-.81572-1.9741-1.29249-3.1325-1.22545-2.5217.06705-4.5629 2.24603-4.4251 4.76774.0671 2.3838 2.0449 4.3579 4.4251 4.425 1.2254.067 2.3838-.4098 3.1995-1.2925.5438-.6146.8865-1.3633.9536-2.179h-4.1531v-1.7022h5.8553c.067.3389.067.6816.067 1.0913.0671 1.4974-.4767 2.9985-1.4973 4.0861-1.1547 1.1547-2.7228 1.8363-4.425 1.6985z",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.744952
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.8853 12.8579c0 2.246-1.84 4.019-4.0861 3.9482-2.246 0-4.019-1.84-3.9482-4.0861 0-2.1789 1.84-3.94821 4.019-3.94821s4.019 1.76931 4.019 3.94821c-.0037.0708-.0037.1379-.0037.1379zm-1.773 0c.1378-1.2255-.8157-2.3839-2.0449-2.4509-1.2254-.1379-2.3838.8157-2.4509 2.0449v.4097c-.1378 1.2254.8157 2.3838 2.0449 2.4509 1.2255.1378 2.3839-.8158 2.4509-2.0449 0-.0671 0-.2049 0-.4097z",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.744952
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.9852 12.8579c0 2.246-1.84 4.019-4.0861 3.9482-2.246 0-4.019-1.84-3.9482-4.0861 0-2.1789 1.84-3.94821 4.019-3.94821s4.019 1.76931 4.019 3.94821c-.0037.0708-.0037.1379-.0037.1379zm-1.7693 0c.1379-1.2255-.8157-2.3839-2.0449-2.4509-1.2254-.1379-2.3838.8157-2.4508 2.0449v.4097c-.1379 1.2254.8157 2.3838 2.0449 2.4509 1.2254.1378 2.3838-.8158 2.4508-2.0449.0671-.0671.0671-.2049 0-.4097z",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.744952
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.0994 9.0437v7.3564c0 2.9984-1.7692 4.2239-3.8812 4.2239-1.5681 0-2.9984-.9536-3.6093-2.3839l1.5682-.6816c.3389.8157 1.1584 1.4303 2.0449 1.4303 1.3632 0 2.1789-.8157 2.1789-2.3838v-.6146h-.067c-.5438.6146-1.3633.9535-2.179.9535-2.246 0-4.0861-1.84-4.0861-4.086 0-2.2461 1.8401-4.08611 4.0861-4.08611.8157 0 1.5681.33895 2.179.88649h.067v-.68163zm-1.6351 3.8812c.1378-1.2925-.8158-2.3838-2.112-2.5217h-.067c-1.2925.0671-2.3168 1.1584-2.246 2.4509-.0671 1.2925.9535 2.3839 2.246 2.4509h.067c1.2925-.067 2.2461-1.0913 2.179-2.3838-.067.0037-.067.0037-.067.0037z",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.744952
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.2321 4.68579v11.98631h-1.7693v-11.98631z",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.744952
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.358 14.2215 1.363.9535c-.749 1.1584-2.045 1.8401-3.404 1.8401-2.1794 0-3.9487-1.7022-4.0195-3.8812 0-.0671 0-.1378 0-.2049 0-2.4509 1.7023-4.08604 3.8145-4.08604 1.568.06704 2.998 1.09135 3.471 2.58874l.205.4767-5.4493 2.2461c.339.7486 1.1583 1.2925 1.9743 1.2254.89 0 1.639-.4097 2.045-1.1584zm-4.2204-1.4303 3.6764-1.4973c-.272-.5439-.887-.8865-1.497-.8865-1.297 0-2.2465 1.0876-2.1794 2.3838-.0671-.067-.0671-.067 0 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m99.1376 12.7912 3.6764-1.4973c-.272-.5439-.887-.8865-1.497-.8865-1.297 0-2.2465 1.0876-2.1794 2.3838zm0 0c-.0671-.067-.0671-.067 0 0zm4.2204 1.4303 1.363.9535c-.749 1.1584-2.045 1.8401-3.404 1.8401-2.1794 0-3.9487-1.7022-4.0195-3.8812 0-.0671 0-.1378 0-.2049 0-2.4509 1.7023-4.08604 3.8145-4.08604 1.568.06704 2.998 1.09135 3.471 2.58874l.205.4767-5.4493 2.2461c.339.7486 1.1583 1.2925 1.9743 1.2254.89 0 1.639-.4097 2.045-1.1584z",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.744952
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.2374 31.0349v-12.2582h1.9331l5.941 9.5093h.0745l-.0745-2.3764v-7.1329h1.5607v12.2582h-1.6352l-6.239-10.0271h-.0745l.0745 2.3764v7.5762h-1.5606z",
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.744952
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.6133 31.2582c-1.1882.0744-2.3019-.447-3.1213-1.2627-.8158-.8903-1.2627-2.004-1.1882-3.1959 0-1.1882.3724-2.3019 1.1137-3.1958.7412-.8902 1.8586-1.3372 2.9723-1.3372 1.1137-.0745 2.2274.3725 2.9724 1.1882.8157.8902 1.1882 2.0784 1.1137 3.2703v.3725h-6.537c0 .7412.298 1.4862.8157 2.0039.5215.447 1.1138.7412 1.7842.7412.9647.0745 1.9332-.5214 2.3019-1.4116l1.4117.5959c-.298.6668-.7412 1.2627-1.3372 1.6352-.6667.447-1.4862.6704-2.3019.596zm2.2274-5.4233c-.0745-.5215-.298-.9647-.6667-1.3372-.5215-.447-1.1137-.6667-1.7842-.6667-.5214 0-1.0392.2235-1.4862.5214-.4469.3725-.7412.8903-.8902 1.4862h4.8273z",
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.744952
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.8007 31.0351h-1.6352l-2.0784-6.3879-2.0784 6.3879h-1.5607l-2.6744-8.3956h1.6352l1.8586 6.3135 2.0785-6.3135h1.6351l2.0784 6.3135 1.8587-6.3135h1.6352z",
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.744952
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.4869 31.2582c-.8158 0-1.6352-.2235-2.3019-.6667-.596-.447-1.0392-1.0392-1.3372-1.7097l1.4117-.5959c.2979.9647 1.2627 1.6351 2.3019 1.5606.4469 0 .8157-.0745 1.1882-.298.2979-.1489.4469-.5214.4469-.8902 0-.5214-.3724-.8902-1.1137-1.1137l-1.7096-.4469c-.5215-.149-1.0392-.3725-1.4862-.7413-.5215-.3724-.7412-.9647-.7412-1.5606 0-.7413.3724-1.4117.9647-1.7842 1.2627-.8157 2.9723-.8902 4.3095-.2235.596.298 1.0392.8157 1.2627 1.4862l-1.3372.596c-.298-.7413-1.1137-1.1882-1.9331-1.1138-.447 0-.8157.0745-1.1882.298-.298.149-.447.447-.447.8158 0 .4469.3725.8157 1.1137.9647l1.6352.3724c.6667.149 1.2627.447 1.7841.9648.3725.4469.596.9647.596 1.4861 0 .7413-.3725 1.4117-.8902 1.8587-.8195.5177-1.7134.8157-2.5291.7412z",
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.744952
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageHeroPressGoogleNews);
export default __webpack_public_path__ + "static/media/imageHeroPressGoogleNews.7accb6128ec45055e07fc01e0c1067c1.svg";
export { ForwardRef as ReactComponent };